<template>
  <div class="user-detail-layout">
    <div>
      <a-card :bordered="false">
        <a-row type="flex">
          <a-col :span="12">
            <div class="detail-status">
              <h4 style="font-weight: 700">
                {{ $t('descriptions.accountStatus') }}
              </h4>
              <div>
                {{ $t('form.userDetail.accountStatus.account') }}：
                <span>{{ userInfo.phone }}</span>
              </div>
              <div>
                <span>{{ userInfo.name }}</span>
                <a-tag
                  color="blue"
                  style="border-radius: 50px; margin-left: 20px"
                >
                  {{
                    form.type == 3
                      ? $t('form.userDetail.accountStatus.subAccount')
                      : $t('form.userDetail.accountStatus.staffAccount')
                  }}
                </a-tag>
              </div>
              <div>
                {{ $t('table.user.thead.superior') }}：
                <span>
                  {{ userInfo.parent_name ? userInfo.parent_name : '' }}
                </span>
              </div>
              <!-- <div>
                {{ $t('table.common.thead.createTime') }}：
                <span>{{ userInfo.create_time }}</span>
              </div> -->
              <div style="display: flex; align-items: center">
                {{ $t('member.membership') }}：
                <span
                  style="font-weight: bold; color: #0d95e8"
                  v-if="userInfo.level != undefined"
                >
                  {{ $t(`enum.userLevel.${userInfo.level}`) }}
                </span>
                <span v-if="userInfo.level" style="margin-left: 15px">
                  {{ userInfo.expire_time }}
                </span>
                <span v-if="userInfo.level">
                  {{ $t('form.userDetail.accountStatus.expire') }}
                </span>
              </div>
            </div>
            <div class="add-new-login">
              <p>新增登入紀錄：</p>
              <a-date-picker
                v-model="time1"
                :disabled-date="disabledDateForLogin"
                @change="onChange"
              ></a-date-picker>
              <a @click="handleAddUserLoginHistory">{{ '確定' }}</a>
            </div>
          </a-col>
          <a-col :span="12">
            <a-row type="flex" align="middle" justify="center">
              <div class="detail-capacity" style="width: 253px">
                <h5>{{ $t('descriptions.totalSpaceCapacity') }}</h5>
                <div class="detail-capacity-icon">
                  <a-progress :percent="userInfo.progress" :show-info="false" />
                  <a class="detail-capacity-increase" @click="setCapacity">
                    {{ $t('form.userDetail.spaceCapacity.setCapacity') }}
                  </a>
                </div>
                <div class="detail-capacity-count" v-cloak>
                  <span>
                    {{ userInfo.g_use_capacity }}G/{{ userInfo.g_capacity }}G
                  </span>
                </div>
              </div>
            </a-row>
            <a-row type="flex" align="middle" justify="center">
              <div class="detail-capacity" style="width: 253px">
                <div class="detail-capacity-icon">
                  <img class="pIcon" src="@/assets/picon.png" />
                  <span class="remainingPoints">
                    <strong>{{ $t('enum.modelOther.points') }}</strong>
                  </span>
                  <span class="pointData">{{ userInfo.point }}點</span>
                  <a class="detail-capacity-increase" @click="setPoint">
                    {{ $t('form.userDetail.setPoint') }}
                  </a>
                </div>
              </div>
            </a-row>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <div style="margin-top: 20px" class="user-detail-info">
      <a-card :bordered="false">
        <h4>{{ $t('moduleTitles.basicInfo') }}</h4>
        <a-form-model
          layout="vertical"
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <!-- 聯繫電話 -->
          <a-form-model-item
            ref="mobile"
            :label="$t('form.userDetail.form.field.mobile.label')"
            prop="phone"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              :placeholder="$t('form.userDetail.form.field.mobile.placeholder')"
              class="user-info-mobile"
              v-model="form.phone"
            />
            <span class="user-info-id">
              {{ $t('form.userDetail.form.field.mobile.userId') }}：
              <span>{{ form.id }}</span>
            </span>
          </a-form-model-item>
          <!-- 聯繫人 -->
          <a-form-model-item
            ref="linkman"
            :label="$t('form.userDetail.form.field.contact.label')"
            prop="linkman"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              :placeholder="
                $t('form.userDetail.form.field.contact.placeholder')
              "
              v-model="form.linkman"
            />
          </a-form-model-item>
          <!-- 會員等級 -->
          <a-form-model-item
            has-feedback
            :label="$t('member.membership')"
            :wrapperCol="{ span: 10 }"
          >
            <a-select
              v-model="form.level"
              :placeholder="$t('member.selectLevelText')"
            >
              <a-select-option :value="0">
                {{ $t('enum.userLevel.0') }}
              </a-select-option>
              <a-select-option :value="1">
                {{ $t('enum.userLevel.1') }}
              </a-select-option>
              <a-select-option :value="2">
                {{ $t('enum.userLevel.2') }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- 會員過期時間 -->
          <a-form-model-item
            has-feedback
            :label="
              $t('member.memberText') +
              '' +
              $t('form.common.field.expireTime.label')
            "
            prop="expire_time"
            :wrapperCol="{ span: 10 }"
            v-if="form.level != 0"
          >
            <a-date-picker
              :valueFormat="dateFormat"
              v-model="form.expire_time"
              :placeholder="$t('form.common.field.expireTime.message')"
            />
          </a-form-model-item>
          <!-- 是否黑鑽 -->
          <a-form-model-item
            :wrapperCol="{ span: 10 }"
            :label="$t('member.isTeamId')"
          >
            <a-radio-group v-model="form.is_team_member">
              <a-radio :value="1">{{ $t('member.yes') }}</a-radio>
              <a-radio :value="0">{{ $t('member.no') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- 黑鑽過期時間 -->
          <a-form-model-item
            has-feedback
            :label="
              $t('member.teamText') +
              '' +
              $t('form.common.field.expireTime.label')
            "
            prop="team_expire_time"
            :wrapperCol="{ span: 10 }"
            v-if="form.is_team_member != 0"
          >
            <a-date-picker
              :valueFormat="dateFormat"
              v-model="form.team_expire_time"
              :placeholder="$t('form.common.field.expireTime.message')"
            />
          </a-form-model-item>
          <!-- 團隊子帳號 -->
          <!--<a-form-model-item v-if="form.type == 3" has-feedback :label="$t('form.user.field.childLimit.label')" prop="child_limit" :wrapperCol="{span:10}">
            <a-input-number v-model="form.child_limit" :placeholder="$t('form.user.field.childLimit.message')"/>
          </a-form-model-item>-->
          <!-- 用戶類型 -->
          <a-form-model-item
            has-feedback
            :label="$t('form.user.field.type.label')"
            :wrapperCol="{ span: 10 }"
            prop="type"
          >
            <a-select
              default-value="lucy"
              v-model="form.type"
              :placeholder="$t('form.user.field.type.message')"
            >
              <a-select-option :value="2">
                {{ $t('enum.userType.2') }}
              </a-select-option>
              <a-select-option :value="3">
                {{ $t('enum.userType.3') }}
              </a-select-option>
              <!-- <a-select-option :value="4">{{$t('enum.userType.4')}}</a-select-option>-->
            </a-select>
          </a-form-model-item>
          <!-- 經銷商 -->
          <a-form-model-item
            has-feedback
            :label="$t('form.user.field.dealer.label')+ '：'"
            :wrapperCol="{ span: 10 }"
            v-if="form.type == 3"
          >
            <a-select
              :showSearch="true"
              :allowClear="true"
              v-model="form.pid"
              abel-in-value
              :default-value="{ key: 0 }"
              :placeholder="$t('form.user.field.dealer.message')+ '：'"
            >
              <a-select-option
                v-for="(item, index) in dealerList"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            :label="$t('form.user.field.store_type.label')+ '：'"
            :placeholder="$t('form.user.field.store_type.message')"
            :wrapperCol="{ span: 10 }"
          >
            <a-select 
              v-model="form.store_type"
              :placeholder="$t('form.user.field.store_type.message')"
            >
              <a-select-option :value="1">{{ $t("enum.store_type[1]") }}</a-select-option>
              <a-select-option :value="2">{{ $t("enum.store_type[2]") }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            :label="$t('form.user.field.store_id.label')+ '：'"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              v-model="form.store_id"
              :placeholder="$t('form.user.field.store_id.message')"
            />
          </a-form-model-item>
          <!--
          <a-form-model-item :wrapperCol="{span:10}" :label="$t('form.common.field.company.label')">
            <a-select
              v-model="form.company"
              label-in-value
              :default-value="{ key: 0 }"
              :placeholder="$t('form.common.field.company.message')"
            >
              <a-select-option value="1">成都總公司</a-select-option>
              <a-select-option value="2">南京分公司</a-select-option>
            </a-select>
          </a-form-model-item>
          -->
          <!-- 所在地區 -->
          <a-form-model-item
            ref="region"
            :label="$t('form.userDetail.form.field.region.label') + '：'"
            :wrapperCol="{ span: 10 }"
          >
            <h-region-select
              @regionData="selectedData"
              :defaultValue="defaultValue"
            ></h-region-select>
          </a-form-model-item>
          <!-- 詳細地址 -->
          <a-form-model-item
            ref="address"
            :label="$t('form.userDetail.form.field.address.label')"
            prop="address"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              v-model="form.address"
              type="textarea"
              :placeholder="
                $t('form.userDetail.form.field.address.placeholder')
              "
              @blur="
                () => {
                  $refs.address.onFieldBlur();
                }
              "
            />
          </a-form-model-item>
          <!-- 用戶簡介 -->
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.briefIntroduction.label')"
            :wrapperCol="{ span: 10 }"
          >
            <a-textarea
              v-model="form.brief"
              :placeholder="
                $t('form.common.field.briefIntroduction.placeholder')
              "
              allow-clear
            />
          </a-form-model-item>
          <!-- 性別 -->
          <a-form-model-item
            :wrapperCol="{ span: 10 }"
            :label="$t('form.common.field.gender.label')"
          >
            <a-radio-group v-model="form.gender">
              <a-radio :value="1">{{ $t('enum.gender.male') }}</a-radio>
              <a-radio :value="0">{{ $t('enum.gender.female') }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- line -->
          <a-form-model-item
            ref="wechat"
            :label="$t('form.userDetail.form.field.line.label')"
            prop="wechat"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              :placeholder="$t('form.userDetail.form.field.line.placeholder')"
              v-model="form.wechat"
            />
          </a-form-model-item>
          <!-- email -->
          <a-form-model-item
            ref="email"
            :label="$t('form.userDetail.form.field.email.label')"
            prop="email"
            :wrapperCol="{ span: 10 }"
          >
            <a-input
              v-model="form.email"
              :placeholder="$t('form.userDetail.form.field.email.placeholder')"
            />
          </a-form-model-item>
          <!-- 底部按鈕 -->
          <footer class="ant-modal-footer">
            <div>
              <button
                type="button"
                class="ant-btn ant-btn-primary"
                @click="handleSubmit"
              >
                <span>{{ $t('actionTitles.submit') }}</span>
              </button>
              <!-- <button type="button" class="ant-btn" @click="onCancel">
                <span>{{$t('message.cancel')}}</span>
              </button>-->
            </div>
          </footer>
        </a-form-model>
      </a-card>
      <a-range-picker
        :valueFormat="dateFormat"
        :disabled-date="disabledDate"
        :showToday="true"
        @change="handleDateRangeChange"
      />
      <!-- 總登入次數 -->
      <LineChartCardAdmin
        ref="loginAreaChart"
        :loading="chartLoading"
        :title="$t('charts.totalLogin')"
        :chartTips="$t('charts.totalLogin')"
        :total="loginRecord.total_count"
        :rightTitle="$t('charts.dayLogin')"
        :rightNum="loginRecord.today_count"
        uniqueId="areacontainer1"
        :startDate="startDate"
        :endDate="endDate"
      ></LineChartCardAdmin>
    </div>

    <a-modal
      v-model="capacityVisible"
      :title="$t('model.capacity.distributionCapacityTitle')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="handleSave"
      width="540px"
    >
      <a-form-model
        ref="capacityForm"
        layout="horizontal"
        :rules="capacityRules"
        :model="capacityForm"
      >
        <a-form-model-item
          :label="$t('form.userDetail.form.field.distributionCapacity.label')"
          prop="capacity"
        >
          <a-input-number
            v-model="capacityForm.capacity"
            :min="1"
            :step="1"
            :placeholder="
              $t('form.userDetail.form.field.distributionCapacity.placeholder')
            "
            style="width: 200px"
          />
          G
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- point -->
    <a-modal
      v-model="pointVisible"
      :title="$t('model.points.distributePointTitle')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="handlePointSave"
      width="540px"
    >
      <a-form-model ref="pointForm" layout="horizontal" :model="pointForm">
        <a-form-model-item
          :label="$t('form.userDetail.form.field.distributionPoint.label')"
          prop="capacity"
        >
          <a-input-number
            v-model="pointForm.point"
            :min="1"
            :step="1"
            :placeholder="
              $t('form.userDetail.form.field.distributionPoint.placeholder')
            "
            style="width: 200px"
          />
          點
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <pay-model
      :userId="userId"
      :visible="renewVisible"
      @close="renewVisible = false"
    ></pay-model>
    <storage-pay-model
      :userId="userId"
      :visible="storageVisible"
      @close="storageVisible = false"
    ></storage-pay-model>
  </div>
</template>
<script>
import HRegionSelect from '@/components/HRegionSelect';
import {
  updateUserInfo,
  userDetail,
  distributionCapacity,
  dealerQueryAll,
  setCapacity,
  setPoint,
  addUserLoginHistory,
} from '@/api/user';
import { validatephone } from '@/utils/validate';
import LineChartCardAdmin from '@/components/Charts/LineChartCardAdmin';
import PayModel from '@/components/PayModel';
import StoragePayModel from '@/components/StoragePayModel';
import moment from 'moment';

export default {
  components: {
    HRegionSelect,
    PayModel,
    StoragePayModel,
    LineChartCardAdmin,
  },
  computed: {
    userId: {
      get() {
        if (this.$route.query.userId != undefined) {
          return parseInt(this.$route.query.userId);
        }
        return 0;
      },
    },
  },
  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t('form.common.field.phone.checkMessage'));
        return;
      }
      callbackFn();
    };
    return {
      chartLoading: false,
      dateFormat: 'YYYY-MM-DD',
      loginRecord: {
        total: 0,
        today: 0,
      },
      form: {
        phone: '',
        gender: 1,
      },
      userInfo: {},
      defaultValue: [],
      rules: {
        phone: [
          {
            required: true,
            message: this.$t('form.userDetail.form.field.mobile.message'),
            trigger: 'blur',
          },
          { validator: phoneCheck, trigger: 'blur' },
        ],
        company: [
          {
            required: true,
            message: this.$t('form.userDetail.form.field.company.message'),
            trigger: 'blur',
          },
        ],
        linkman: [
          {
            required: true,
            message: this.$t('form.userDetail.form.field.contact.message'),
            trigger: 'blur',
          },
        ],
        child_limit: [
          {
            required: true,
            message: this.$t('form.user.field.childLimit.message'),
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: this.$t('form.userDetail.form.field.address.message'),
            trigger: 'blur',
          },
        ],
        email: [
          {
            type: 'email',
            message: this.$t('form.userDetail.form.field.email.checkMessage'),
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: this.$t('form.user.field.type.message'),
            trigger: 'change',
          },
        ],
      },
      capacityRules: {
        capacity: [
          {
            required: true,
            message: this.$t(
              'form.userDetail.form.field.distributionCapacity.message'
            ),
            trigger: 'blur',
          },
        ],
      },
      renewVisible: false,
      dealerList: [],
      storageVisible: false,
      // dateFormat: "YYYY-MM-DD",
      capacityVisible: false,
      pointVisible: false,
      capacityForm: {
        capacity: '',
      },
      pointForm: {
        point: '',
      },
      startDate: null,
      endDate: null,
      time1: undefined,
      loginTime: undefined,
    };
  },
  mounted() {
    dealerQueryAll().then((res) => {
      this.dealerList = res.data;
    });
    this.loadData();
  },
  watch: {
    // startDate(newValue, oldValue) {
    //   console.log('startDate newValue', newValue);
    //   console.log('startDate oldValue', oldValue);
    // },
    // endDate(newValue, oldValue) {
    //   console.log('endDate newValue', newValue);
    //   console.log('endDate oldValue', oldValue);
    // }
  },
  methods: {
    onChange(value, dateString) {
      this.loginTime = dateString;
    },
    disabledDateForLogin(current) {
      return current && current > moment().endOf('day');
    },
    clearTime() {
      this.time1 = undefined;
      this.loginTime = undefined;
    },
    async handleAddUserLoginHistory() {
      try {
        console.log('loginTime:', this.loginTime);
        console.log('userId:', this.userId);
        let response = await addUserLoginHistory({
          id: this.userId,
          date: this.loginTime,
        });
        console.log('addUserLoginHistory的response:', response);
        this.clearTime();
      } catch (error) {
        console.log('addUserLoginHistory的error:', error);
      }
    },
    loadData() {
      this.userInfo = {};
      userDetail({ id: this.userId }).then((res) => {
        this.form = res.data;
        this.userInfo = { ...res.data };
        this.userInfo.expire_time = this.userInfo.expire_time.substring(0, 11);
        this.userInfo.create_time = this.userInfo.create_time.substring(0, 11);
        this.defaultValue = res.data.parent_regoin;
        this.capacityForm.id = this.userInfo.id;
        this.loginRecord.total_count = this.userInfo.loginRecord.total_count;
        this.loginRecord.today_count = this.userInfo.loginRecord.today_count;
        //獲取登入次數圖表數據
        const userData = res.data.loginRecord;
        // console.log('userData', userData);
        // 將用戶的登錄次數數據設置為圖表所需的數據
        this.updateLoginChartsData(userData.statistics_data);
      });
    },
    handleSubmit() {
      // e.preventDefault();
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          updateUserInfo(this.form).then((res) => {
            this.$message.success(this.$i18n.t('message.saveSuccess'));
            this.$router.push({
              path: '/admin/user/list',
            });
          });
        }
      });
    },
    selectedData(val) {
      this.form.region = val;
    },
    renew() {
      this.renewVisible = true;
    },
    setCapacity() {
      this.capacityForm.capacity = '';
      setTimeout(() => {
        this.$refs['capacityForm'].resetFields();
      }, 0);
      this.capacityVisible = true;
      // this.storageVisible = true;
    },
    handleSave() {
      this.$refs.capacityForm.validate((valid) => {
        if (valid) {
          setCapacity(this.capacityForm).then((res) => {
            this.$message.success(this.$i18n.t('message.saveSuccess'));
            this.capacityVisible = false;
            this.loadData();
          });
        }
      });
    },
    setPoint() {
      this.pointVisible = true;
      this.pointForm.point = '';
    },
    handlePointSave() {
      // console.log('UID:', this.userId);
      // console.log('Point Value:', this.pointForm.point);
      this.$refs.pointForm.validate((valid) => {
        if (valid) {
          const param = {
            id: this.userId,
            point: this.pointForm.point,
          };
          setPoint(param).then((res) => {
            this.$message.success(this.$i18n.t('message.saveSuccess'));
            this.pointVisible = false;
            this.loadData();
            location.reload();
          });
        }
      });
    },
    updateLoginChartsData(data) {
      this.$refs.loginAreaChart.update(data);
    },
    disabledDate(current) {
      // return current && current > moment().endOf('day');
      const today = moment().startOf('day');
      const statDates = this.userInfo.loginRecord.statistics_data.map(
        (item) => item.stat_date
      );

      if (!current.isSame(today, 'day')) {
        return !statDates.some((date) => {
          const startDate = moment(date).startOf('day');
          const endDate = moment(date).endOf('day');
          return current.isBetween(startDate, endDate, null, '[]');
        });
      }
    },
    handleDateRangeChange(newRange) {
      if (newRange.length === 0) {
        this.loadData();
      } else {
        // 獲取起始日期和結束日期
        const startDate = moment(newRange[0]);
        const endDate = moment(newRange[1]);

        // 產生日期範圍內的日期列表
        const datesInRange = [];
        let currentDate = moment(startDate);
        while (currentDate.isSameOrBefore(endDate)) {
          datesInRange.push(currentDate.format('YYYY-MM-DD'));
          currentDate.add(1, 'day');
        }

        // 儲存更新後的數據
        // 用 map 遍歷 datesInRange 中的每一個日期
        const updatedData = datesInRange.map((date) => {
          const item = this.userInfo.loginRecord.statistics_data.find(
            (data) => data.stat_date === date
          );
          if (item) {
            return {
              stat_date: date,
              visit_count: item.visit_count,
            };
          } else {
            return {
              stat_date: date,
              visit_count: 0,
            };
          }
        });
        this.updateLoginChartsData(updatedData);
      }
      // console.log('newRange', newRange);
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

.detail-status > div {
  margin-bottom: 8px;
}

.pIcon {
  width: 10%;
}

.add-new-login {
  display: flex;
  align-items: center;
  gap: 10px;
}
.add-new-login > p {
  margin: 0;
}
</style>
